<template>
  <v-carousel height="300">
    <v-carousel-item
      v-for="(item, i) in items"
      :key="i"
      reverse-transition="fade-transition"
      transition="fade-transition"
    >
      <div>
        <v-btn
          v-if="isAdmin"
          class="absoluteButton"
          fab
          small
          text
          @click="deleteImage(item)"
        >
          <v-icon dark>
            <slot name="button">
              close
            </slot>
          </v-icon>
        </v-btn>
        <v-img
          :aspect-ratio="16 / 9"
          class="grey darken-4"
          lazy-src="https://picsum.photos/id/11/10/6"
          :src="item.path"
          height="300"
        ></v-img>
      </div>
    </v-carousel-item>
  </v-carousel>
</template>

<style lang="scss" scoped>
.centerImg {
  margin: auto;
}
.absoluteButton {
  position: absolute;
  z-index: 9999;
  right: 10px;
  top: 2px;
}
</style>

<script>
export default {
  props: {
    items: Array,
    isAdmin: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data() {
    return {}
  },
  methods: {
    deleteImage(item) {
      this.$emit('deleteImage', item)
    }
  }
}
</script>
